import React from "react";
import { GameNotificationSpecialSeatBlock } from "../../../src/server/models/game/modules/notifications/blocks";
import PlayerAvatar from "../../user/avatar";
import { SPECIAL_SEAT_IMAGE_MAP } from "@/src/enum/game";
import { getSpecialSeatName } from "@/src/enum/game";

type Props = {
    block: GameNotificationSpecialSeatBlock;
}

const SIZE = '16px';

export default function NotificationSpecialSeat(
    {
        block,
    }: Props,
): React.ReactNode {
    const avatar = SPECIAL_SEAT_IMAGE_MAP[block.seatNumber];

    return <span style={{ fontWeight: 'bold' }}>
        {avatar && <PlayerAvatar
            src={avatar}
            style={{
                maxWidth: SIZE,
                maxHeight: SIZE,
                marginRight: '4px',
            }}
        />}
        {getSpecialSeatName(block.seatNumber)}
    </span>
}
